import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useEffect} from "react";

const SortByHeader = ({orderRef, name, attr}) => {
    const [param, setParam] = useState({
        name: name,
        active: false,
        direction: 1,
        attr: attr,
    });

    useEffect(() => {
        // Se ejecuta solo una vez al montar el componente

        // Comprueba si este header debe estar activo al inicio
        if (orderRef.current.param?.attr === attr) {
            setParam((p) => ({...p, active: true, direction: orderRef.current.param.direction}));
        }

        // Creamos la función que manejará los eventos
        const handleOrderEvent = () => {
            // Si el evento lo ha lanzado otro header, este se desactiva
            if (orderRef.current.param?.attr !== attr) {
                setParam((p) => ({...p, active: false}));
            }
        };

        // Añadimos nuestro manejador al array de eventos
        orderRef.current.events.push(handleOrderEvent);

        // ¡Esta es la clave! Devolvemos una función de limpieza.
        // React la ejecutará cuando el componente se desmonte.
        return () => {
            orderRef.current.events = [];
        };
    }, []);

    const onClickOrder = () => {
        if (param.active) {
            orderRef.current.param = {attr: param.attr, direction: param.direction * -1};
            setParam({...param, direction: param.direction * -1});
            orderRef.current.clickOrder();
            return;
        }
        setParam({...param, active: true});
        orderRef.current.param = {attr: param.attr, direction: 1};
        orderRef.current.clickOrder();
    };

    const onClickDeactivate = () => {
        setParam({...param, active: false, direction: 1});
        orderRef.current.param = {};
        orderRef.current.clickOrder();
    };

    return (
        <div>
            <span onClick={() => onClickOrder()} className="d-inline-flex align-items-center" style={{cursor: "pointer"}}>
                {param.name}
            </span>
            {param.active && (
                <span className="d-inline-flex">
                    {param.direction === 1 ? (
                        <FontAwesomeIcon icon="caret-up" className="text-secondary px-1" />
                    ) : (
                        <FontAwesomeIcon icon="caret-down" className="text-secondary px-1" />
                    )}
                </span>
            )}
            {param.active && (
                <button className="btn btn-link text-secondary p-0" type="button" onClick={onClickDeactivate}>
                    <FontAwesomeIcon icon="xmark" />
                </button>
            )}
        </div>
    );
};

export default SortByHeader;
